var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0332 0.392578H3.03323C1.30485 0.473643 -0.0345881 1.93363 0.0332272 3.66258L0.0361568 11.8197C-0.0316584 13.5487 1.30778 15.0086 3.03616 15.0897H6.77616C6.67369 15.7277 6.51986 16.3564 6.31616 16.9697L5.97616 17.9097C5.87394 18.1607 5.89602 18.4452 6.03575 18.6774C6.17548 18.9097 6.41651 19.0625 6.68616 19.0897H12.3862C12.6558 19.0625 12.8968 18.9097 13.0366 18.6774C13.1763 18.4452 13.1984 18.1607 13.0962 17.9097L12.7562 16.9697C12.5525 16.3564 12.3986 15.7277 12.2962 15.0897H16.0362C17.7645 15.0086 19.104 13.5487 19.0362 11.8197L19.0332 3.66258C19.101 1.93363 17.7616 0.473643 16.0332 0.392578ZM7.68616 17.5897V17.4697C7.90297 16.8575 8.07017 16.2288 8.18616 15.5897H10.8062C10.9268 16.2277 11.094 16.856 11.3062 17.4697V17.5897H7.68616ZM16.0362 13.5897C16.9339 13.505 17.5999 12.7192 17.5362 11.8197V3.77629C17.5999 2.87681 16.9339 2.09095 16.0362 2.00629H3.03616C2.1384 2.09095 1.47242 2.87681 1.53616 3.77629V11.8197C1.47242 12.7192 2.1384 13.505 3.03616 13.5897H16.0362Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.44092,
    y: 3.06543,
    width: 14.1386,
    height: 7.89635,
    rx: 0.6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.44092,
    y: 11.5974,
    width: 14.1386,
    height: 1.15202,
    rx: 0.576008,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/webIcon.1da31fbb9ceff61519504dc699dd2362.svg";
export { ForwardRef as ReactComponent };